<template>
    <div style="background: black;">
        <img :src="imagePath" class="full_img" @click="showMessage = true" alt="PR"/>
        <custom-dialog v-show="showMessage" :show-message='showMessage' :sub-message='"何も操作をせずに、そのままスタッフに\nこの端末をお渡しください。"'
                        @dialogClick="dialogClick" @bodyClick="dialogBodyClick" :type="0"/>
    </div>
</template>
<script>
import CustomDialog from "@/components/CustomDialog.vue";
import {getAdInfo} from "@/utils/api";
export default {
    name: 'prView',
    components: {
        CustomDialog
    },
    data() {
        return {
            imagePath: null,
            showMessage: false,
            imageList: [],
            timer: null,
            index: 0
        }
    },
    mounted() {
        // TODO: Read pr list from server

        this.startPrExchangeTimer();
        const that = this;
        getAdInfo()
            .then(function (res){
                console.log(JSON.stringify(res))
                if (res && res.ret === 200 && res.data) {
                    const tmp = [];
                    let count = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        let tempInfo = res.data[i];
                        console.log(JSON.stringify(tempInfo))
                        if (tempInfo.is_display == 0){
                            tmp[count++] = tempInfo.url;
                            if (count>=10){
                                break;
                            }
                        }
                    }
                    console.log(JSON.stringify(tmp))
                    that.$set(that,"imageList",tmp);
                    that.index = 0;
                    that.prExchange();
                }

            })
            .catch(function (err){
                console.error(err)
            })
    },
    methods: {
        dialogClick() {
            window.document.location = "/ss/index.php";
        },
        dialogBodyClick() {
            this.showMessage = false;
        },
        startPrExchangeTimer() {
            this.prExchange();
            this.timer = setInterval(this.prExchange, 10000);
        },
        prExchange() {
            if (this.index >= this.imageList.length) {
                this.index = 0;
            }
            if (this.index < this.imageList.length) {
                this.imagePath = this.imageList[this.index];
            }
            this.index++;
        }
    }
}

</script>
<style scoped>
body {
    background-color: black;
}

.full_img {
    background-color: black;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>